class ClientLoggerService {
  public error(error: any, additionalMessage?: string): void {
    if (!window.DD_RUM) return;

    window.DD_RUM.onReady(function () {
      if (additionalMessage) {
        window.DD_RUM.addError(error, { customMessage: additionalMessage });
      } else {
        window.DD_RUM.addError(error);
      }
    });
  }
}

export const clientLoggerService = new ClientLoggerService();
